import { createFileRoute, redirect } from "@tanstack/react-router";
import * as v from "valibot";
import { wellKnownQuery } from "@/api/matrix";
import { CreateUserContainer } from "@/features/users/create/container";
import { userMessages } from "@/features/users/messages";
import { operationQuery } from "@/features/users/services/api";

export const Route = createFileRoute("/_console/users_/create")({
  validateSearch: v.object({
    operation: v.optional(v.pipe(v.string(), v.uuid())),
  }),
  staticData: { breadcrumb: { message: userMessages.createTitle } },
  loaderDeps: ({ search }) => ({ operation: search.operation ?? "" }),
  beforeLoad: ({ search }) => {
    if (!search.operation)
      throw redirect({
        to: "/users/create",
        search: { operation: crypto.randomUUID() },
        replace: true,
      });
  },
  loader: async ({ context: { queryClient, credentials }, deps }) => {
    const wellKnown = await queryClient.ensureQueryData(
      wellKnownQuery(credentials.serverName),
    );
    const root = wellKnown["m.homeserver"].base_url;
    await queryClient.fetchQuery(operationQuery(root, deps.operation));
    return { root, operationId: deps.operation };
  },
  component: CreateUserPage,
});

function CreateUserPage() {
  const { credentials } = Route.useRouteContext();
  const { root, operationId } = Route.useLoaderData();
  return (
    <CreateUserContainer
      key={operationId}
      root={root}
      serverName={credentials.serverName}
      operationId={operationId}
    />
  );
}
